import { stegaClean } from 'next-sanity';

function normalizeTabLabel(text?: string | null): string {
  if (!text) return '';
  return stegaClean(text).trim().toLowerCase();
}

/** Header nav link overrides that differ from Sanity settings. */
const HEADER_NAV_LINK_OVERRIDES: Record<string, { anchor: string }> = {
  'how it works': {
    anchor: '#meet-babs',
  },
};

export function resolveHeaderNavLink<T extends { text?: string | null; anchor?: string | null }>(
  link: T
): T {
  const override = HEADER_NAV_LINK_OVERRIDES[normalizeTabLabel(link.text)];
  if (!override) return link;

  return {
    ...link,
    ...override,
  };
}
